import { requestGet, requestPost } from '@/utils/requestTourist';

// 页面访问埋点
export function postAccessLog(params: any) {
  return requestPost(`/v2/camp/api/burying/point/access/log`, params);
}
// 观看埋点
export function postVideoLog(params: any) {
  return requestPost(`/v2/camp/api/video/log`, params);
}
// 学习节点埋点
export function postStudyNodeLog(params: any) {
  return requestPost(`/v2/camp/api/burying/point/study/node/log`, params);
}
